import { call, select, put, takeLatest, all, take } from "redux-saga/effects";
import {
  addBankAccountSuccess,
  addBankAccountFailure,
  getBankAccountSuccess,
  getBankAccountFailure,
  deleteBankAccountSuccess,
  deleteBankAccountFailure,
  makeDefaultBankAccountSuccess,
  makeDefaultBankAccountFailure,
  viewBankAccountSuccess,
  viewBankAccountFailure,
  withinPayUserListSuccess,
  withinPayUserListFailure,
  createWithinPayUserSuccess,
  createWithinPayUserFailure,
  deleteWithinPayUserSuccess,
  deleteWithinPayUserFailure,
  singleViewWithinPayUserSuccess,
  singleViewWithinPayUserFailure,
  sendMoneyWithinPaySuccess,
  sendMoneyWithinPayFailure,
  whitelistAddressListSuccess,
  whitelistAddressListFailure,
  createWhitelistAddressSuccess,
  createWhitelistAddressFailure,
  deleteWhitelistAddressSuccess,
  deleteWhitelistAddressFailure,
  singleViewWhitelistAddressSuccess,
  singleViewWhitelistAddressFailure,
  staticExchangeRateSuccess,
  staticExchangeRateFailure,
  staticEmailListSuccess,
  staticEmailListFailure,
  bvnkFeesSuccess,
  bvnkFeesFailure,
  sdkKeyGenerateSuccess,
  sdkKeyGenerateFailure,
  withdrawalDownloadSuccess,
  withdrawalDownloadFailure,
  verifyCodeResetPasswordSuccess,
  verifyCodeResetPasswordFailure,
  acceptInviteSuccess,
  acceptInviteFailure,
} from "../actions/BankAccountAction";
import {
  ADD_BANK_ACCOUNT_START,
  GET_BANK_ACCOUNT_START,
  DELETE_BANK_ACCOUNT_START,
  MAKE_DEFAULT_BANK_ACCOUNT_START,
  VIEW_BANK_ACCOUNT_START,
  WITHIN_PAY_USER_LIST_START,
  CREATE_WITHIN_PAY_USER_START,
  DELETE_WITHIN_PAY_USER_START,
  SINGLE_VIEW_WITHIN_PAY_USER_START,
  SEND_MONEY_WITHIN_PAY_START,
  WHITELIST_ADDRESS_LIST_START,
  CREATE_WHITELIST_ADDRESS_START,
  DELETE_WHITELIST_ADDRESS_START,
  SINGLE_VIEW_WHITELIST_ADDRESS_START,
  STATIC_EXCHANGE_RATE_START,
  STATIC_EMAIL_LIST_START,
  BVNK_FEES_START,
  SDK_KEY_GENERATE_START,
  WITHDRAWAL_DOWNLOAD_START,
  VERIFY_CODE_RESET_PASSWORD_START,
  ACCEPT_INVITE_START,
} from "../actions/ActionConstant";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/ToastNotification";
import api from "../../components/Environment";

function* addBankAccountAPI(action) {
  let bankAccountData = yield select((state) => state.bankAccount.bankAccount.data);
  try {
    const response = yield api.postMethod("bank_accounts/store", action.data);

    if (response.data.success) {
      yield put(addBankAccountSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
      if (Object.keys(bankAccountData).length > 0) {
        yield put(getBankAccountSuccess({
          ...bankAccountData,
          bank_accounts: action.data.user_bank_account_id ?
            bankAccountData.bank_accounts.map((account) => account.id == action.data.user_bank_account_id ?
              response.data.data.bank_account : account)
            :
            [response.data.data.bank_account, ...bankAccountData.bank_accounts]
        }));
      }
    } else {
      yield put(addBankAccountFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(addBankAccountFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* getBankAccountAPI(action) {
  try {
    const response = yield api.postMethod("bank_accounts", action.data);

    if (response.data.success) {
      yield put(getBankAccountSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(getBankAccountFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(getBankAccountFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* deleteAccountBankAccountAPI(action) {
  let bankAccountData = yield select((state) => state.bankAccount.bankAccount.data);
  try {
    const response = yield api.postMethod("bank_accounts/destroy", action.data);
    if (response.data.success) {
      yield put(deleteBankAccountSuccess(response.data));
      yield call(getSuccessNotificationMessage, response.data.message);
      if (Object.keys(bankAccountData).length > 0) {
        yield put(getBankAccountSuccess({
          ...bankAccountData,
          total_bank_accounts: response.data.total_bank_accounts,
          bank_accounts: bankAccountData.bank_accounts.filter(account =>
            (account.id != action.data.user_bank_account_id)),
        }));
      }
    } else {
      yield put(deleteBankAccountFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(deleteBankAccountFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* makeDefaultBankAccountAPI(action) {
  let bankAccountData = yield select((state) => state.bankAccount.bankAccount.data);
  try {
    const response = yield api.postMethod("bank_accounts/default", action.data);
    if (response.data.success) {
      yield put(makeDefaultBankAccountSuccess(response.data));
      yield call(getSuccessNotificationMessage, response.data.message);
      if (Object.keys(bankAccountData).length > 0) {
        yield put(getBankAccountSuccess({
          ...bankAccountData,
          bank_accounts: bankAccountData.bank_accounts.map(account =>
            account.id == response.data.data.bank_account.id
              ? { ...account, is_default: 1 } :
              { ...account, is_default: 0 },
          )
        }));
      }
    } else {
      yield put(makeDefaultBankAccountFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(deleteBankAccountFailure(error));
    yield call(makeDefaultBankAccountFailure, error.message);
  }
}

function* viewBankAccountAPI(action) {
  try {
    const response = yield api.postMethod("bank_accounts/show", action.data);

    if (response.data.success) {
      yield put(viewBankAccountSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(makeDefaultBankAccountFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(viewBankAccountFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* withinPayUserListAPI(action) {
  try {
    const response = yield api.postMethod("withinpay_users", action.data);

    if (response.data.success) {
      yield put(withinPayUserListSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(withinPayUserListFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(withinPayUserListFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* createWithinPayUserAPI(action) {
  try {
    const response = yield api.postMethod("withinpay_users/store", action.data);

    if (response.data.success) {
      yield put(createWithinPayUserSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(createWithinPayUserFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(createWithinPayUserFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* deleteWithinPayUserAPI(action) {
  try {
    const response = yield api.postMethod("withinpay_users/delete", action.data);

    if (response.data.success) {
      yield put(deleteWithinPayUserSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(deleteWithinPayUserFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(deleteWithinPayUserFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* singleViewWithinPayUserAPI(action) {
  try {
    const response = yield api.postMethod("withinpay_users/show", action.data);

    if (response.data.success) {
      yield put(singleViewWithinPayUserSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(singleViewWithinPayUserFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(singleViewWithinPayUserFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* sendMoneyWithinPayUserAPI(action) {
  try {
    const response = yield api.postMethod("internal_transfer", action.data);

    if (response.data.success) {
      yield put(sendMoneyWithinPaySuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(sendMoneyWithinPayFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(sendMoneyWithinPayFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

// Whitelist Address
function* whitelistAddressListAPI(action) {
  try {
    const response = yield api.postMethod("whitelist_wallet_addresses", action.data);

    if (response.data.success) {
      yield put(whitelistAddressListSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(whitelistAddressListFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(whitelistAddressListFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* createWhitelistAddressAPI(action) {
  try {
    const response = yield api.postMethod("whitelist_wallet_addresses/store", action.data);

    if (response.data.success) {
      yield put(createWhitelistAddressSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(createWhitelistAddressFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(createWhitelistAddressFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* deleteWhitelistAddressAPI(action) {
  try {
    const response = yield api.postMethod("whitelist_wallet_addresses/delete", action.data);

    if (response.data.success) {
      yield put(deleteWhitelistAddressSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(deleteWhitelistAddressFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(deleteWhitelistAddressFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* singleViewWhitelistAddressAPI(action) {
  try {
    const response = yield api.postMethod("whitelist_wallet_addresses/show", action.data);

    if (response.data.success) {
      yield put(singleViewWhitelistAddressSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(singleViewWhitelistAddressFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(singleViewWhitelistAddressFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* staticExchangeRateAPI(action) {
  try {
    const response = yield api.postMethod("bvnk_exchange_rates", action.data);

    if (response.data.success) {
      yield put(staticExchangeRateSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(staticExchangeRateFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(staticExchangeRateFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* staticEmailListAPI(action) {
  try {
    const response = yield api.postMethod("custom_user_settings", action.data);

    if (response.data.success) {
      yield put(staticEmailListSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(staticEmailListFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(staticEmailListFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* bvnkFeesAPI(action) {
  try {
    const response = yield api.postMethod("bvnk_fees", action.data);

    if (response.data.success) {
      yield put(bvnkFeesSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(bvnkFeesFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(bvnkFeesFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* sdkKeyGenerateAPI(action) {
  try {
    const response = yield api.postMethod("view_sdk_api_key", action.data);

    if (response.data.success) {
      yield put(sdkKeyGenerateSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(sdkKeyGenerateFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(sdkKeyGenerateFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* withdrawalDownloadAPI(action) {
  try {
    const response = yield api.postMethod("user_withdrawals/invoice", action.data);

    if (response.data.success) {
      yield put(withdrawalDownloadSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(withdrawalDownloadFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(withdrawalDownloadFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* verifyCodeResetPasswordAPI(action) {
  try {
    const response = yield api.postMethod("verify_forgot_password_code", action.data);

    if (response.data.success) {
      yield put(verifyCodeResetPasswordSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(verifyCodeResetPasswordFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(verifyCodeResetPasswordFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

function* acceptInviteAPI(action) {
  try {
    const response = yield api.postMethod("accept_invite", action.data);
    if (response.data.success) {
      yield put(acceptInviteSuccess(response.data.data));
      yield call(getSuccessNotificationMessage, response.data.message);
    } else {
      yield put(acceptInviteFailure(response.data.error));
      yield call(getErrorNotificationMessage, response.data.error);
    }
  } catch (error) {
    yield put(acceptInviteFailure(error));
    yield call(getErrorNotificationMessage, error.message);
  }
}

export default function* BankAccountSaga() {
  yield all([
    yield takeLatest(ADD_BANK_ACCOUNT_START, addBankAccountAPI),
    yield takeLatest(GET_BANK_ACCOUNT_START, getBankAccountAPI),
    yield takeLatest(DELETE_BANK_ACCOUNT_START, deleteAccountBankAccountAPI),
    yield takeLatest(MAKE_DEFAULT_BANK_ACCOUNT_START, makeDefaultBankAccountAPI),
    yield takeLatest(VIEW_BANK_ACCOUNT_START, viewBankAccountAPI),
    yield takeLatest(WITHIN_PAY_USER_LIST_START, withinPayUserListAPI),
    yield takeLatest(CREATE_WITHIN_PAY_USER_START, createWithinPayUserAPI),
    yield takeLatest(DELETE_WITHIN_PAY_USER_START, deleteWithinPayUserAPI),
    yield takeLatest(SINGLE_VIEW_WITHIN_PAY_USER_START, singleViewWithinPayUserAPI),
    yield takeLatest(SEND_MONEY_WITHIN_PAY_START, sendMoneyWithinPayUserAPI),  
    // Whitelist Address
    yield takeLatest(WHITELIST_ADDRESS_LIST_START, whitelistAddressListAPI),
    yield takeLatest(CREATE_WHITELIST_ADDRESS_START, createWhitelistAddressAPI),
    yield takeLatest(DELETE_WHITELIST_ADDRESS_START, deleteWhitelistAddressAPI),
    yield takeLatest(SINGLE_VIEW_WHITELIST_ADDRESS_START, singleViewWhitelistAddressAPI),
    yield takeLatest(STATIC_EXCHANGE_RATE_START, staticExchangeRateAPI),
    yield takeLatest(STATIC_EMAIL_LIST_START, staticEmailListAPI),
    yield takeLatest(BVNK_FEES_START, bvnkFeesAPI),
    yield takeLatest(SDK_KEY_GENERATE_START, sdkKeyGenerateAPI),
    yield takeLatest(WITHDRAWAL_DOWNLOAD_START, withdrawalDownloadAPI),
    yield takeLatest(VERIFY_CODE_RESET_PASSWORD_START, verifyCodeResetPasswordAPI),
    yield takeLatest(ACCEPT_INVITE_START, acceptInviteAPI),
  ])
}

